<template>
    <div class="intro icon-bolt">
        <h1>
            Huidige jaarbonus<span
                class="icon-info"
                data-popover="bonusopbouwPopover"
                @click="showPopover"
                @mouseenter="showPopover"
            />
        </h1>
        <h2>&euro; {{ formatCurrency(yearBonus.amount) }}</h2>
        <div v-if="yearBonus.expectedAmount" class="expected">
            {{ bonusText }}
            <span>&euro; {{ formatCurrency(yearBonus.expectedAmount) }}</span>
        </div>
        <span class="sidenote"
            >Zowel de huidige jaarbonus als de verwachte jaarbonus zijn
            gecorrigeerd voor het verwachte percentage werkgeverslasten</span
        >
        <div
            v-show="!hidePopover"
            id="bonusopbouwPopover"
            class="bonus-opbouw popover"
        >
            <div class="popover-heading">
                <h5 class="header">Bonusopbouw</h5>
                <span class="icon-close" @click="closePopover" />
            </div>
            <div class="popover-content">
                <p>
                    De huidige jaarbonus bestaat uit de som van alle definitieve
                    maandbonussen, min de werkgeverslasten. Fictief voorbeeld
                    van de berekening:
                </p>
                <p>
                    <span>Huidige berekening:</span>
                    <span>bonus = €19.000</span>
                    <span>werkgeverslasten = 18%</span>
                    <span
                        >huidige jaarbonus = (19.000 / 118) * 100 =
                        €16.101,69</span
                    >
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';
export default {
    mixins: [RockCurrencyMixin],
    props: ['yearBonus', 'final'],
    data() {
        return {
            hidePopover: true
        };
    },
    computed: {
        bonusText: function () {
            if (this.final) {
                return 'Verwachte jaarbonus';
            }
            return 'Jaarbonus';
        }
    },
    methods: {
        showPopover(e) {
            this.positionPopover(e);
            this.hidePopover = false;
        },
        closePopover() {
            this.hidePopover = true;
        },
        positionPopover(e) {
            const elementPos = e.target.getBoundingClientRect();
            const leftPos = elementPos.left + 25;
            const popoverId = e.target.getAttribute('data-popover');
            document
                .getElementById(popoverId)
                .setAttribute(
                    'style',
                    `left: ${leftPos}px; top: ${elementPos.top}px;`
                );
        }
    }
};
</script>
